import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/js/bootstrap.min"
import {auth} from "@/firebase/config";

let app;
auth.onAuthStateChanged(()=>{
    if (!app){
        app = createApp(App).use(store).use(router).mount('#app');
    }
});
